import {
  Bot,
  ClipboardList,
  GraduationCap,
  History,
  NotebookPen,
  UserRound,
  Wand2,
  type LucideIcon,
} from "lucide-react";

import { listSessions } from "@/lib/session-api";
import { listNotebooks, listNotebookEntries } from "@/lib/notebook-api";
import { listPersonas } from "@/lib/personas-api";
import { listSkills } from "@/lib/skills-api";
import { fetchAllProgress } from "@/lib/learning-api";
import { getAgents } from "@/lib/chat-import/agent-store";


export type SpaceKey =
  | "chat_history"
  | "mastery_path"
  | "agents"
  | "notebooks"
  | "question_bank"
  | "personas"
  | "skills";

export interface SpaceSection {
  key: SpaceKey;
  href: string;
  icon: LucideIcon;
  /** English source string; rendered through i18next `t()`. */
  title: string;
  /** Live count for the tab badge. Every section is a real backend signal, so
   *  the badge never shows an invented number. */
  load: () => Promise<number>;
}

// SSOT for the /space tabs — array order is tab order. Lifted from the old
// dashboard's GROUPS so the counts stay identical; the dashboard is gone.
export const SPACE_SECTIONS: SpaceSection[] = [
  {
    key: "chat_history",
    href: "/space/chat-history",
    icon: History,
    title: "Chat History",
    load: async () => (await listSessions(200, 0, { force: true })).length,
  },
  {
    key: "mastery_path",
    href: "/space/learning",
    icon: GraduationCap,
    title: "Mastery Path",
    load: async () =>
      (await fetchAllProgress()).summaries.filter((s) => s.kp_count > 0).length,
  },
  {
    key: "agents",
    href: "/space/agents",
    icon: Bot,
    title: "My Agents",
    load: async () => (await getAgents()).length,
  },
  {
    key: "notebooks",
    href: "/space/notebooks",
    icon: NotebookPen,
    title: "Notebooks",
    load: async () => (await listNotebooks()).length,
  },
  {
    key: "question_bank",
    href: "/space/questions",
    icon: ClipboardList,
    title: "Question Bank",
    load: async () => (await listNotebookEntries({ limit: 1 })).total,
  },
  {
    key: "personas",
    href: "/space/personas",
    icon: UserRound,
    title: "Personas",
    load: async () => (await listPersonas()).length,
  },
  {
    key: "skills",
    href: "/space/skills",
    icon: Wand2,
    title: "Skills",
    load: async () => (await listSkills()).length,
  },
];

